<div fxLayout="row wrap" class="header">
  <div class="left-menu">
    <button *ngIf="isEditable"
            mat-mini-fab
            color="none"
            [disabled]="isDuplicateModActive"
            [matTooltip]="'AgendaExport' | translate"
            (click)="sessionExport()">
      <i class="material-icons">
        how_to_reg
      </i>
    </button>
    <button *ngIf="isEditable"
            mat-mini-fab
            color="none"
            [disabled]="isDuplicateModActive"
            [matTooltip]="'Agenda_Duplication_Mode' | translate"
            (click)="onDuplicateModeClicked()">
      <i class="material-icons">
        filter_none
      </i>
    </button>
    <button *ngIf="isEditable"
            mat-button
            [disabled]="isDuplicateModActive"
            [matTooltip]="'Empty_calendar_tooltip' | translate"
            (click)="onEmptyCalendarClicked()">
      <mat-icon>delete_sweep</mat-icon>
      <span>{{ 'Empty_calendar' | translate }}</span>
    </button>
  </div>
  <agendas-week-selector [date]="currentDate" [beforeDateChangeHook$]="beforeDateChangeHook$"></agendas-week-selector>
  <div class="flex-1-1">
    <div *ngIf="!isSummaryHidden"
         class="summary">
      <div [matTooltip]="'Intensity_hint' | translate">
        <div class="legend">{{ 'Intensity' | translate }}</div>
        <div class="value" [class.warn]="totalIntensity > availableIntensity">
          {{ totalIntensity }} % / {{ availableIntensity }} %
        </div>
      </div>
      <div class="separator"></div>
      <div [matTooltip]="'Working_time_hint' | translate">
        <div class="legend">{{ 'Working_time' | translate }}</div>
        <div class="value" [class.warn]="totalTime > availableTime">
          {{ totalTime | secondsToDHM:true:true | default:'-' }} / {{ availableTime | secondsToDHM:true:true | default:'-' }} ({{ (totalTime * 100 / availableTime) || 0 | round }} % / {{ availableTimePercent }} %)
        </div>
      </div>
    </div>
  </div>
</div>

<div style="visibility: hidden; position: fixed"
     [style.left]="contextMenuPosition.x"
     [style.top]="contextMenuPosition.y"
     [matMenuTriggerFor]="contextMenu">
</div>
<mat-menu #contextMenu="matMenu">
  <ng-template matMenuContent let-item="item">
    <button
      mat-menu-item
      [disabled]="!this.copyPasteBuffer.containSomething()"
      (click)="onContextMenuPasteAction(item)">
      {{ 'Paste_session' | translate }}
    </button>
  </ng-template>
</mat-menu>
<div *ngIf="data && data.length" class="container">
  <div class="time-container">
    <div class="time-cell calendar-header"></div>
    <ng-container *ngFor="let segment of data[0].segments; let i = index;">
      <div *ngIf="i % timeSegments == 0"
           class="time-cell first-line"
           [class.expandable]="isSegmentCollapsed(segment)"
           [style.height.px]="getSegmentHeight(segment)"
           (click)="onExpand(segment, $event)">
        <ng-container *ngIf="isSegmentVisible(segment)">
          <div>
            {{ segment.timeStr }}
          </div>
          <button mat-icon-button
                  class="left"
                  [matTooltip]="'Hide_from' | translate"
                  (click)="collapse(segment, 'before', $event)">
            <mat-icon>expand_less</mat-icon>
          </button>
          <button mat-icon-button
                  class="right"
                  [matTooltip]="'Hide_to' | translate"
                  (click)="collapse(segment, 'after', $event)">
            <mat-icon>expand_more</mat-icon>
          </button>
        </ng-container>
      </div>
    </ng-container>
  </div>
  <div class="days-container">
    <div *ngFor="let dayData of data" class="day-container">
      <div class="day-cell calendar-header">
        <div>{{ dayData.date | appDate:'E':'':currentLocale }}</div>
        <div>{{ utils.DateToYmdHis(dayData.date, true) | dateClosest:'LLLd' }}</div>
      </div>
      <div
        *ngFor="let segment of dayData.segments; let i = index"
        class="day-cell slots-container clickable"
        cdkDropList
        [cdkDropListData]="segment"
        (cdkDropListDropped)="onItemDropped($event)"
        (cdkDropListEntered)="onDragEntered(segment)"
        (cdkDropListExited)="onDragExited(segment)"
        (contextmenu)="onOpenContextMenu($event, segment)"
        [class.first-line]="i % timeSegments == 0"
        [class.expandable]="isSegmentCollapsed(segment)"
        [style.height.px]="getSegmentHeight(segment) / timeSegments"
        (click)="onExpand(segment, $event)"
      >
        <div *ngIf="segment.displayTime" class="time">{{ segment.timeStr }}</div>
        <!-- Use isSegmentVisible to conditionally display content -->
        <ng-container *ngIf="isSegmentVisible(segment)">
          <agendas-calendar-event
            *ngFor="let slot of segment.slots"
            [timeSegments]="timeSegments"
            [lineHeight]="lineHeight"
            [class.hidden]="segment.displayTime"
            cdkDrag
            (cdkDragStarted)="onDrag($event, segment)"
            [cdkDragData]="slot"
            [cdkDragDisabled]="!isEditable"
            [slot]="slot"
            [organization]="organization"
            [athleteUser]="athleteUser"
            [currentUrl]="currentUrl ?? ''"
            [isEditable]="isEditable"
            (onRefresh)="onRefresh.emit()"
          >
            <!-- Event Content -->
            <!-- Drag Handle -->
            <mat-icon
              cdkDragHandle
              before-title-section
              drag-handle
              [class.hidden]="!isEditable || isDuplicateModActive"
            >
              drag_indicator
            </mat-icon>
            <!-- Duplicate Mode Checkbox -->
            <mat-icon
              *ngIf="isEditable && isDuplicateModActive"
              class="event-checkbox"
              before-title-section
              (click)="onSlotSelectedChanged($event, slot)"
            >
              {{ isCheckedForDuplication(slot) ? 'check_box' : 'check_box_outline_blank' }}
            </mat-icon>
            <!-- More Menu -->
            <button
              mat-icon-button
              more-section
              [matMenuTriggerFor]="moreMenu"
              [class.hidden]="!isEditable || isDuplicateModActive"
            >
              <mat-icon>more_vert</mat-icon>
            </button>
            <mat-menu #moreMenu="matMenu" xPosition="before">
              <button mat-menu-item (click)="onDuplicateSlotClicked(segment, slot)">
                <mat-icon>file_copy</mat-icon>&nbsp;{{ 'Copy_session' | translate }}
              </button>
              <button mat-menu-item (click)="onRepeatSlotClicked(segment, slot)">
                <mat-icon>redo</mat-icon>&nbsp;{{ 'Repeat' | translate }}
              </button>
              <button mat-menu-item (click)="onDeleteSlotClicked(segment, slot)">
                <mat-icon>delete_outlined</mat-icon>&nbsp;{{ 'Delete' | translate }}
              </button>
            </mat-menu>
          </agendas-calendar-event>
        </ng-container>
      </div>
    </div>
  </div>

</div>
